import React,{ useState, useEffect } from "react";
import Form from 'react-bootstrap/Form';
import CountrySelector from './countryselector';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import PhoneInput from 'react-phone-number-input';
import Payment  from './payment';
import { useLocation } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import AdditionalCredits from './additionalcredits';
import { useNavigate } from "react-router-dom";
import Select from 'react-select';

function AccountDetails({ loggedInUserId, onSuccess }){
    const [accountName, setAccountName] = useState(null);
    const [accountEmail, setAccountEmail] = useState();
    const [accountZipcode, setAccountZipcode] = useState();
    const [accountCity, setAccountCity] = useState();
    const [country, setCountry] = useState(null);
    const [ipInfo, setIpInfo] = useState(null);
    const [phone, setPhone] = useState(null);
    const [address, setAddress] = useState(null);
    const [showPaymentForm, setShowPaymentForm] = useState(false);
    const [userData, setUserData] = useState({
        loggedInUserId: loggedInUserId,
        accountid: '',
        name: '',
        email: '',
        postalcode: '',
        city: '',
        country: '',
        address: '',
        phone:'',
        stateid:'',
        gstnumber:'',
        ismanualsubscription:false,
      });
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const planid = searchParams.get('id');
    const stype = searchParams.get('type');
    const period = searchParams.get('period');
    // const zones = searchParams.get('zones');
    const [currency, setCurrency] = useState(searchParams.get('currency'));
    const [additionalCreditsdModal, setAdditionalCreditsModal] = useState(false)
    const hideadditionalCreditsdModal = () => setAdditionalCreditsModal(false);
    const [accountStatus, setAccountStatus] = useState('create')
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [states, setStates] = useState();
    const [selectedState, setSelectedState] = useState();
    const [visibleState, setVisibleState] = useState(false);
    const [gstnumber,setGstNumber] = useState();
    const [validateGST, setValidateGST] = useState(false);
    const [isautosubscription, setIsautosubscription] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                
                const response = await axios.get(`/account/${loggedInUserId}`);
                if(response.status === 200){
                    setAccountName(response.data[0].name);
                    setAccountEmail(response.data[0].email);
                    setAccountZipcode(response.data[0].postalcode);
                    setAccountCity(response.data[0].city);
                    setAddress(response.data[0].address);
                    setPhone(response.data[0].phone);
                    setCountry(response.data[0].country);
                    response.data[0].country == 'IN' ? setVisibleState(true) : setVisibleState(false);
                    setGstNumber(response.data[0].gstnumber);
                    setAccountStatus('update')
                    setUserData(prevState => ({
                        ...prevState,
                        accountid : response.data[0].id,
                        name: response.data[0].name,
                        email: response.data[0].email,
                        postalcode: response.data[0].postalcode,
                        city: response.data[0].city,
                        address: response.data[0].address,
                        country : response.data[0].country,
                        phone : response.data[0].phone,
                        stateid : response.data[0].stateid,
                        gstnumber : response.data[0].gstnumber,
                    }));
                }else{
                    setAccountStatus('create')
                }
                
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
}, [loggedInUserId]);

    useEffect(() => {
        const fetchData = async () => {
            
                try {
                    const response = await axios.get(`/getstates/${country}`);
                    const stateData = response.data.map(state => ({
                        id:state.value,
                        value: state.code,
                        label: state.label
                      }));
                    setStates(stateData);
                    const defaultState = stateData.find(state => state.id == userData.stateid);
                    setSelectedState(defaultState);
                } catch (error) {
                    console.error('Error fetching data:', error);
                }        
        };
    
        // Check if the country is defined and non-null before calling fetchData
        if (country !== null && visibleState) {
            fetchData();
        } 
    }, [country]);

    const handleCountryChange = async (selectedCountry) => {
        setCountry(selectedCountry.value);
        setCurrency(selectedCountry.value == 'IN' ? 1 : 2);
        setUserData((prevState) => ({
            ...prevState,
            country: selectedCountry.value,
          }));
        selectedCountry.value == 'IN' ? setVisibleState(true) : setVisibleState(false);
    };

    const handleIpInfoFetched = (data) => {
        setIpInfo(data);
    };

    const handleAccountNameChange = (e) => {
        setAccountName(e.target.value);
        setUserData((prevState) => ({
            ...prevState,
            name: e.target.value,
          }));
    };

    const handleAccountEmailChange = (e) => {
        setAccountEmail(e.target.value);
        setUserData((prevState) => ({
            ...prevState,
            email: e.target.value,
          }));
    };

    const handleAccountCityChange = (e) => {
        setAccountCity(e.target.value);
        setUserData((prevState) => ({
            ...prevState,
            city: e.target.value,
          }));
    };

    const handleAccountZipcodeChange = (e) => {
        setAccountZipcode(e.target.value);
        setUserData((prevState) => ({
            ...prevState,
            postalcode: e.target.value,
          }));
    };

    const handleAddressChange = (e) => {
        setAddress(e.target.value);
        setUserData((prevState) => ({
            ...prevState,
            address: e.target.value,
          }));
    };

    const handlePhoneChange = (value) => {
        setPhone(value);
        setUserData((prevState) => ({
          ...prevState,
          phone: value,
        }));
    };
    async function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        try {
            var response
            setLoading(true)
            if(accountStatus == 'create'){
                response = await axios.post('/addaccountdetails', { loggedInUserId, userData });
            }else{
                response = await axios.post('/updateaccountdetails', { loggedInUserId, userData });
            }
            if(response){
                if (onSuccess) {
                    onSuccess();
                    return; // stop here
                }
                if (currency === 1 && stype === 'subscription' && !isautosubscription) {
                    console.log("condition true")
                    await axios.post('/create-razorpay-payment-link', {
                        loggedInUserId,
                        planid,
                        stype,
                        period,
                        userData
                    });

                    alert("Payment link sent to your email");
                    setLoading(false);
                    navigate('/mmain');
                }

                if(stype == 'additional'){
                    setAdditionalCreditsModal(true)
                }else{
                    setShowPaymentForm(true);
                }
                
            }
        }catch(error){
            console.log("error", error)
        }    
    }
    const handleCancel = () =>{
        navigate('/mmain');
    }

    const handleStateChange = (selectedOption) => {
        setSelectedState(selectedOption);
        setUserData((prevState) => ({
            ...prevState,
            stateid: selectedOption.id,
          }));
      };

    const handleAccountGSTNumberChange = (e) => {
        setGstNumber(e.target.value);
        setValidateGST(true);
        setUserData((prevState) => ({
            ...prevState,
            gstnumber: e.target.value,
          }));
    };

     const handleIsManualSubscriptionChange = (e) => {
        setIsautosubscription(e.target.checked);
        setUserData((prevState) => ({
            ...prevState,
            ismanualsubscription: e.target.checked,
          }));
      };
    const isValidGST = (!validateGST) || (/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gstnumber));

    return(
        <>
        <div className="h-100 d-flex align-items-center justify-content-center">
          <div className="p-4 border shadow align-items-center" style={{ width:'700px'}}>
          <h3 className="text-center fs-4 mb-4">Payment Information</h3>
          <Form className='row g-3' onSubmit={handleSubmit}>
                <Form.Group className="col-md-6" controlId="companyname">
                    <Form.Label>Name : </Form.Label>
                    <Form.Control required type="text" placeholder="Company Name" value={accountName} onChange={handleAccountNameChange}/>
                </Form.Group>
                <Form.Group className="col-md-6" controlId="billingemail">
                    <Form.Label>Email : </Form.Label>
                    <Form.Control required type="email" placeholder="Billing Email" value={accountEmail} onChange={handleAccountEmailChange}/>
                </Form.Group>
                <Form.Group className="col-md-12" controlId="billingemail">
                    <Form.Label>Address : </Form.Label>
                    <Form.Control required type="text" placeholder="Billing Address" value={address} onChange={handleAddressChange}/>
                </Form.Group>
                <Form.Group className="col-md-6" controlId="city">
                    <Form.Label>City : </Form.Label>
                    <Form.Control required type="text" placeholder="City" value={accountCity} onChange={handleAccountCityChange}/>
                </Form.Group>
                <Form.Group className="col-md-6" controlId="zipcode">
                    <Form.Label>Zip Code : </Form.Label>
                    <Form.Control required type="text" placeholder="Zip Code" value={accountZipcode} onChange={handleAccountZipcodeChange}/>
                </Form.Group>
                <Form.Group className="col-md-6">
                    <Form.Label controlId='signup_usercountry'>Country</Form.Label>
                    <CountrySelector onCountryChange={handleCountryChange} onIpInfoFetched={handleIpInfoFetched} country={country}/>
                </Form.Group>
                <Form.Group className="col-md-6">
                    <Form.Label controlId='signup_usercountry'>Contact : </Form.Label>
                    <PhoneInput
                        placeholder="Enter phone number"
                        value={phone}
                        onChange={ handlePhoneChange }
                        defaultCountry={country}
                        className='form-control'
                    />
                </Form.Group>
                {visibleState && (
                    <Form.Group className="col-md-6">
                        <Form.Label controlId='signup_usercountry'>State</Form.Label>
                        <Select
                            options={states}
                            value={selectedState}
                            onChange={handleStateChange}
                        />
                    </Form.Group>
                )}
                {visibleState && (
                    <Form.Group className="col-md-6">
                        <Form.Label controlId='signup_usercountry'>GST Number</Form.Label>
                        <Form.Control required type="text" placeholder="GST" value={gstnumber} onChange={handleAccountGSTNumberChange} isInvalid={!isValidGST}/>
                        <Form.Control.Feedback type="invalid">
                            Enter valid GST number
                        </Form.Control.Feedback>
                    </Form.Group>
                )}
                <Form.Group className="col-md-6 d-flex align-items-center">
                    <Form.Label className="me-3 mb-0">Auto Subscription</Form.Label>
                    <Form.Check
                        type="switch"
                        id="manual-subscription-switch"
                        checked={isautosubscription}
                        onChange={handleIsManualSubscriptionChange}
                    />
                </Form.Group>

                {loading && <div className='w-100 text-success text-center' >Processing, please wait...</div>}
                <div class="d-flex justify-content-end">
                    <Button onClick={handleCancel} variant='outline-secondary me-4'>Cancel</Button>

                    <Button type="submit" variant='primary' disabled={loading}>Proceed to Pay</Button>
                </div>
                
            </Form>
          </div>
        </div>
        {showPaymentForm && <Payment showPaymentForm={true} userData={userData} setShowPaymentForm={setShowPaymentForm} planid={planid} stype={stype} period={period} currency={currency} isautosubscription={isautosubscription}/>}
        <style>
            {`
            .PhoneInputInput {
                border: none;
                outline: none;
            }
            `}
        </style>
        <Modal show={additionalCreditsdModal} onHide={hideadditionalCreditsdModal} animation={true} centered size='md'>
            <Modal.Body>

                 <AdditionalCredits hideadditionalCreditsdModal={hideadditionalCreditsdModal} loggedInUserId={loggedInUserId}/>

            </Modal.Body>
        </Modal>

        </>
        
    )
}

export default AccountDetails;